var _ = function _(t) {
    return t;
  },
  _t,
  _t2,
  _t3,
  _t4,
  _t5,
  _t6,
  _t7,
  _t8,
  _t9,
  _t10,
  _t11,
  _t12,
  _t13,
  _t14;
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.reflect.get.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
import { LitElement, html } from 'lit';
import css from './style.pcss';
import getTranslations from './translations';
var RTLWalenGemengenKandidaten = /*#__PURE__*/function (_LitElement) {
  _inherits(RTLWalenGemengenKandidaten, _LitElement);
  function RTLWalenGemengenKandidaten() {
    var _this;
    _classCallCheck(this, RTLWalenGemengenKandidaten);
    _this = _callSuper(this, RTLWalenGemengenKandidaten);
    _this.municipalities = [];
    _this.version = undefined;
    _this.currentMunicipality = undefined;
    _this.municipality = undefined;
    _this.currentParty = 0;
    _this.party = undefined;
    _this.inline = false;
    _this.lang = "lu";
    _this.api = "https://static.rtl.lu/walen-gemengen-2023/walen_communes.json";
    return _this;
  }
  _createClass(RTLWalenGemengenKandidaten, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      _get(_getPrototypeOf(RTLWalenGemengenKandidaten.prototype), "connectedCallback", this).call(this);
      this.translations = getTranslations(this.lang);
      this._fetchData();
    }
  }, {
    key: "_fetchData",
    value: function _fetchData() {
      var _this2 = this;
      fetch(this.api).then(function (result) {
        return result.json();
      }).then(function (result) {
        _this2.municipalities = result.communes;
        _this2.version = result.version;
        //if (this.inline) this.currentMunicipality = this.municipalities[0].id;
      });
    }
  }, {
    key: "_renderCandidates",
    value: function _renderCandidates() {
      var _this3 = this;
      if (!this.municipality) return '';
      var candidats;
      if (this.municipality.type === 'p') candidats = this.party.candidats;else candidats = this.municipality.candidats;
      return html(_t || (_t = _`
            <div class="wlg-candidates">
                ${0}
            </div>
        `), candidats.map(function (candidat) {
        return html(_t2 || (_t2 = _`
                        <div class="card candidat${0}">
                            ${0}
                            <div class="candidat__info">
                                <div class="candidat__header">
                                    <h4 class="candidat__name">${0} ${0}${0}</h4>
                                    <div class="candidat__role">${0}</div>
                                </div>
                                ${0}
                                ${0}
                                ${0}
                            </div>
                        </div>
                    `), candidat.top_candidat ? ' candidat--top' : '', candidat.photo != undefined ? html(_t3 || (_t3 = _`<div class="candidat__image"><rtl-img src="${0}?v=${0}" width="240" height="270"></rtl-img></div>`), candidat.photo, _this3.version) : '', candidat.firstname, candidat.lastname, candidat.sex ? html(_t4 || (_t4 = _` (${0})`), candidat.sex) : '', candidat.actual_role, candidat.age ? html(_t5 || (_t5 = _`<div class="candidat__age">${0}: ${0} ${0}</div>`), _this3.translations.age, candidat.age, _this3.translations.years) : '', candidat.job ? html(_t6 || (_t6 = _`<div class="candidat__job">${0}: ${0}</div>`), _this3.translations.profession, candidat.job) : '', candidat.first_year ? html(_t7 || (_t7 = _`<div class="candidat__firstyear">Éischt Kandidatur: ${0}</div>`), candidat.first_year) : '');
      }));
    }
  }, {
    key: "_renderParties",
    value: function _renderParties() {
      var _this4 = this;
      if (!this.municipality) return '';
      if (this.municipality.type === 'm') return '';
      return html(_t8 || (_t8 = _`
            <div class="wlg-candidats-nav-container">
                <ul class="wlg-candidats-nav">
                ${0}
                </ul>
            </div>
        `), this.municipality.parties.map(function (party, i) {
        return html(_t9 || (_t9 = _`<li class="wlg-candidats-nav__item${0}" @click=${0}>${0}</li>`), _this4.currentParty === i ? ' wlg-candidats-nav__item--selected' : '', function (e) {
          return _this4.currentParty = i;
        }, party.name);
      }));
    }
  }, {
    key: "_handleChange",
    value: function _handleChange(e) {
      this.currentMunicipality = e.target.value;
      this.currentParty = 0;
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;
      if (!this.municipalities) return html(_t10 || (_t10 = _`Loading...`));
      if (this.currentMunicipality) {
        this.municipality = this.municipalities.filter(function (municipality) {
          return municipality.id == this.currentMunicipality;
        }.bind(this))[0];
      }
      if (this.municipality && this.municipality.type === 'p') {
        this.party = this.municipality.parties.filter(function (party, i) {
          return i === this.currentParty;
        }.bind(this))[0];
      }
      return html(_t11 || (_t11 = _`
            <style>${0}</style>
            <div class="wlg-candidats">
                ${0}
                <div class="wlg-select">
                    <select @change=${0}>
                        <option disabled hidden selected>${0}</option>
                        ${0}
                    </select>
                </div>

                ${0}
                ${0}

                ${0}
            </div>
        `), css, !this.inline ? html(_t12 || (_t12 = _`
                    <div class="wlg-candidats__header">
                        <div class="wlg-candidat__logo">
                            <svg id="Calque_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 1286.81 354.42"><defs><clipPath id="clippath"><rect x="918.81" width="368" height="207.32" fill="none"/></clipPath></defs><g><path d="m49.05,208.42L0,4.54V1.59h37.52l33.68,154.53h1.18L111.69,1.59h39l39.89,154.53h1.18L224.86,1.59h37.53v2.95l-49.35,203.88h-43.14l-37.82-150.99h-1.18l-39,150.99h-42.84Z"/><path d="m271.25,131.89c0-48.16,25.41-78.89,64.41-78.89,18.91,0,34.87,7.39,45.21,20.98h1.18l4.13-17.73h31.03v152.17h-31.03l-4.13-18.02h-1.18c-10.05,13.59-25.41,21.27-44.32,21.27-39.3,0-65.3-31.91-65.3-79.78Zm112.28,0c0-29.55-14.48-47.57-39-47.57s-37.53,17.73-37.53,47.57,14.18,48.16,37.53,48.16,39-18.32,39-48.16Z"/><path d="m499.36,208.42c-30.43,0-46.69-14.18-46.69-45.21V1.59h35.16v161.92c0,10.34,5.61,15.36,17.14,15.36h3.55v29.55h-9.16Z"/><path d="m521.22,132.19c0-46.09,28.07-79.19,75.05-79.19s72.39,30.73,72.39,74.46v14.48h-111.1c0,24.23,15.07,40.18,40.48,40.18,16.55,0,29.84-7.39,34.28-20.39h34.28c-4.43,29.55-33.39,49.94-68.55,49.94-48.75,0-76.82-33.39-76.82-79.48Zm111.39-15.07c-.59-20.09-13-34.57-36.34-34.57s-37.23,14.48-38.41,34.57h74.75Z"/><path d="m695.26,208.42V56.25h31.32l2.66,18.61h1.18c8.27-12.71,22.75-21.87,44.62-21.87,33.68,0,54.96,21.27,54.96,55.55v99.87h-35.16v-91.01c0-20.68-9.46-32.8-30.43-32.8s-33.98,14.77-33.98,39.3v84.51h-35.16Z"/></g><g><path d="m6.08,297.19c0-23.62,13.83-38.51,34.26-38.51,16.81,0,29.04,10,30.53,24.89h-9.58c-1.07-9.58-9.58-16.17-20.96-16.17-15.11,0-24.68,11.6-24.68,29.79s9.58,29.36,24.9,29.36c14.04,0,22.77-9.79,22.77-23.09h-20.43v-8.51h29.26v6.38c0,20.43-12.66,33.94-31.6,33.94-20.64,0-34.47-14.58-34.47-38.09Z"/><path d="m80.66,307.08c0-15.75,9.04-28.19,25.64-28.19s24.58,11.38,24.58,26.49v4.36h-40.85c0,10.32,5.96,17.55,17.24,17.55,6.81,0,12.34-3.09,13.94-8.83h8.94c-1.49,10-11.6,16.81-22.87,16.81-17.34,0-26.6-12.23-26.6-28.19Zm40.96-4.79c0-8.62-4.89-15.43-15.32-15.43s-15.85,6.92-16.17,15.43h31.49Z"/><path d="m220.03,298.89v35.32h-8.94v-33.94c0-8.72-4.26-13.41-12.24-13.41-8.51,0-13.62,6.49-13.62,17.34v30h-8.94v-33.94c0-8.72-4.15-13.41-12.02-13.41-8.62,0-13.83,6.49-13.83,17.34v30h-8.94v-54.26h7.77l.75,8.41h.43c3.3-6.28,8.72-9.47,16.28-9.47s13.41,3.4,16.38,9.47h.43c3.19-6.17,9.25-9.47,17.55-9.47,11.81,0,18.94,7.45,18.94,20Z"/><path d="m229.61,307.08c0-15.75,9.04-28.19,25.64-28.19s24.58,11.38,24.58,26.49v4.36h-40.85c0,10.32,5.96,17.55,17.24,17.55,6.81,0,12.34-3.09,13.94-8.83h8.94c-1.49,10-11.6,16.81-22.87,16.81-17.34,0-26.6-12.23-26.6-28.19Zm40.96-4.79c0-8.62-4.89-15.43-15.32-15.43s-15.85,6.92-16.17,15.43h31.49Z"/><path d="m290.47,334.21v-54.26h7.77l.75,8.41h.43c2.87-5.53,8.4-9.47,16.81-9.47,12.02,0,19.04,7.55,19.04,20v35.32h-8.94v-33.94c0-8.51-3.94-13.41-12.55-13.41-9.04,0-14.36,6.38-14.36,17.34v30h-8.94Z"/><path d="m347.71,337.19h8.94c.75,5.64,6.17,9.26,14.26,9.26,10,0,14.89-6.17,14.89-17.45v-4.36h-.43c-3.94,5.53-10.11,8.51-17.77,8.51-13.51,0-22.77-10.96-22.77-27.02s9.15-27.24,23.62-27.24c7.13,0,13.3,3.19,16.92,8.62h.43l1.17-7.55h7.77v47.77c0,17.02-8.51,26.7-23.83,26.7-13.19,0-22.02-6.7-23.19-17.24Zm38.3-31.07c0-12.02-6.28-19.26-16.6-19.26-9.79,0-15.53,7.13-15.53,19.26s5.74,19.04,15.53,19.04c10.32,0,16.6-7.13,16.6-19.04Z"/><path d="m405.37,307.08c0-15.75,9.04-28.19,25.64-28.19s24.58,11.38,24.58,26.49v4.36h-40.85c0,10.32,5.96,17.55,17.24,17.55,6.81,0,12.34-3.09,13.94-8.83h8.94c-1.49,10-11.6,16.81-22.87,16.81-17.34,0-26.6-12.23-26.6-28.19Zm40.96-4.79c0-8.62-4.89-15.43-15.32-15.43s-15.85,6.92-16.17,15.43h31.49Z"/><path d="m466.23,334.21v-54.26h7.77l.75,8.41h.43c2.87-5.53,8.4-9.47,16.81-9.47,12.02,0,19.04,7.55,19.04,20v35.32h-8.94v-33.94c0-8.51-3.94-13.41-12.55-13.41-9.04,0-14.36,6.38-14.36,17.34v30h-8.94Z"/><path d="m546.87,334.21v-7.02l25.43-29.36c7.66-8.94,10.64-12.45,10.64-18.72,0-7.23-4.36-12.34-13.3-12.34s-13.94,5-13.94,14.04h-9.04c0-12.98,8.4-22.13,22.98-22.13s22.56,8.72,22.56,20.11c0,8.3-4.36,13.94-13.72,24.68l-19.26,22.02v.43h34.15v8.3h-46.49Z"/><path d="m605.6,296.76c0-25.11,8.83-38.09,25.96-38.09s25.96,12.98,25.96,38.09-8.83,38.51-25.96,38.51-25.96-13.09-25.96-38.51Zm42.66,0c0-20.11-5.53-30-16.7-30s-16.7,9.89-16.7,30,5.42,30.43,16.7,30.43,16.7-9.89,16.7-30.43Z"/><path d="m668.91,334.21v-7.02l25.43-29.36c7.66-8.94,10.64-12.45,10.64-18.72,0-7.23-4.36-12.34-13.3-12.34s-13.94,5-13.94,14.04h-9.04c0-12.98,8.4-22.13,22.98-22.13s22.56,8.72,22.56,20.11c0,8.3-4.36,13.94-13.72,24.68l-19.26,22.02v.43h34.15v8.3h-46.49Z"/><path d="m725.51,313.68h8.94c.11,7.66,5.42,13.62,15.53,13.62s15.43-5.53,15.43-13.83c0-8.94-6.06-14.04-16.49-14.04h-6.49v-7.98h6.28c8.51,0,14.36-4.89,14.36-12.55,0-6.7-4.04-12.24-13.3-12.24s-13.94,5.32-14.26,12.98h-9.04c.64-13.09,9.15-20.96,23.62-20.96,12.77,0,22.34,7.55,22.34,19.58,0,8.3-3.72,13.19-11.17,16.06v.43c8.72,2.77,13.51,9.68,13.51,18.62,0,12.34-8.83,21.92-24.68,21.92-14.89,0-24.58-8.62-24.58-21.6Z"/></g><g clip-path="url(#clippath)"><g><rect x="918.28" y=".59" width="368" height="207.32" fill="#0c75ed"/><g><path d="m1155.36,277.96l-193.23-50.05,50.05-193.23,193.23,50.04-50.05,193.23Zm-158.42-70.53l137.93,35.72,35.72-137.93-137.93-35.72-35.72,137.93Z" fill="#fff"/><g><polygon points="1245.62 59.43 1216.11 27.89 1107.52 129.52 1074.79 94.55 1043.26 124.07 1105.63 190.71 1137.17 161.2 1137.04 161.06 1245.62 59.43" fill="#fff"/><path d="m1105.38,198.28l-69.7-74.47,39.36-36.83,32.73,34.97,108.59-101.63,36.83,39.35-108.6,101.64.13.14-39.35,36.83Zm-54.56-73.97l55.06,58.83,23.72-22.21-.13-.14,108.58-101.62-22.2-23.72-108.59,101.63-32.73-34.97-23.72,22.2Z" fill="#0c75ed"/></g></g></g></g></svg>
                        </div>
                        <h1 class="wlg-candidat__title">Kandidaten</h1>
                    </div>
                `)) : '', function (e) {
        return _this5._handleChange(e);
      }, this.translations.select, this.municipalities.map(function (municipality) {
        return html(_t13 || (_t13 = _`<option value="${0}" ?selected=${0}>${0}</option>`), municipality.id, _this5.currentMunicipality === municipality.id ? true : false, municipality.name);
      }), this._renderParties(), this._renderCandidates(), this.municipality ? html(_t14 || (_t14 = _`
                    <div class="wlg-candidates__message">
                        ${0}
                    </div>
                `), this.translations.additional_infos) : '');
    }
  }], [{
    key: "properties",
    get: function get() {
      return {
        municipalities: {
          type: Array
        },
        version: {
          type: Number
        },
        currentMunicipality: {
          type: Number
        },
        currentParty: {
          type: Number
        },
        inline: {
          type: Boolean
        },
        lang: {
          type: String
        }
      };
    }
  }]);
  return RTLWalenGemengenKandidaten;
}(LitElement);
export { RTLWalenGemengenKandidaten as default };
window.customElements.define('rtl-walen-gemengen-kandidaten', RTLWalenGemengenKandidaten);